import React, { useState, useEffect, useRef } from "react";
import { API } from "aws-amplify";
import Papa from "papaparse";
import CustomStepper from "../components/CustomStepper2";
import CustomTabs from "../components/CustomTabs2";
import { Box } from "@mui/material";
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';

import Tooltip from '@material-ui/core/Tooltip';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import DownloadIcon from '@material-ui/icons/GetApp';
import IconButton from '@material-ui/core/IconButton';

import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import { HighlightWithinTextarea } from 'react-highlight-within-textarea';
import "../containers/Prompt.css";
import LoadingModal from "./LoadingModal";
import InsertsChecklist from "./InsertsCheckList";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";




export default function TabDomains(props) {
  //const { project, docRef, updateConfig, config, updateSteps, onDocUpdated, disabled, models } = props;
  const { docid, docItemStatus, docPhase, updateConfig, config, startPipeline, disabled, models } = props;
  const [tabStep, setTabStep] = useState(0);
  const [activeStep, setActiveStep] = React.useState(-1);


  const [tabProcess, setTabProcess] = useState(0);


  const [promptUserP1, setPromptUserP1] = useState("");
  const [promptSysP1, setPromptSysP1] = useState("");
  const [promptUserP2, setPromptUserP2] = useState("");
  const [promptSysP2, setPromptSysP2] = useState("");
  const [promptUserP3, setPromptUserP3] = useState("");
  const [promptSysP3, setPromptSysP3] = useState("");
  //const [sdoList, setSdoList] = useState("");
  //const [validatorOptions, setValidatorOptions] = useState("");
  const [validatorResults, setValidatorResults] = useState("");
  // const [enrichedNtab, setEnrichedNtab] = useState("");
  const [p1Results, setP1Results] = useState("");
  const [p2Results, setP2Results] = useState("");
  const [p3Results, setP3Results] = useState("");

  const [temperature, setTemperature] = useState(0.0);
  const [topP, setTopP] = useState(1.0);
  const [presencePenalty, setPresencePenalty] = useState(0.0);
  const [frequencyPenalty, setFrequencyPenalty] = useState(0.0);
  const [selectedModel, setSelectedModel] = useState("gpt-4.1-mini");


  //const [ntabId, setNtabId] = useState(null);

  //const [promptId, setPromptId] = useState(null);

  //const [isProcessing, setIsProcessing] = useState(false);



  //const [ntabArtefacts, setNtabArtefacts] = useState([]);







  //const [domLookup, setDomLookup] = useState([]);






  const [copied, setCopied] = useState(false);

  //const [prompt, setPrompt] = useState("");

  //const [files, setFiles] = useState([]);
  const [processingState, setProcessingState] = useState({ currentIndex: 0, isActive: false, userKey: 1 });
  const [isRunning, setIsRunning] = useState(false);
  const [resultsStatus, setResultsStatus] = useState('');
  const [isCancelling, setIsCancelling] = useState(false);
  const [resultsData, setResultsData] = useState("");
  const startTimeRef = useRef(0);
  const indexRef = useRef(0);
  const processTextRef = useRef("");



  const [statusText, setStatusText] = useState("");
  const [processText, setProcessText] = useState("");

    const [completePipeline, setCompletePipeline] = useState(false);


  const [steps, setSteps] = useState([
    { id: 1, title: "P1", subtitle: "", code: "P1", extractionType: "p1", completed: false, exists: false },
    { id: 2, title: "P2", subtitle: "", code: "P2", extractionType: "p2", completed: false, exists: false },
    { id: 3, title: "P3", subtitle: "", code: "P3", extractionType: "p3", completed: false, exists: false },
    /*{ id: 4, title: "Validation", code: "Validation", extractionType: "validation", subtitle: "", completed: false, exists: false },*/

  ]);



  useEffect(() => {
    //updateTabsAndSteps();
    loadConfig();
  }, []);




/*
  useEffect(() => {
    //console.log("polling");
    let pollingInterval;
    if (isRunning && promptId) {
      pollingInterval = setInterval(pollStatus, 5000); // Check every 5 seconds
    }
    try {
      return () => clearInterval(pollingInterval); // Clear polling on unmount or when parsing stops
    } catch (e) {
      // do nowt
    }

  }, [isRunning, promptId]);
*/

/*
  useEffect(() => {
    let pollingInterval;
    if (isRunning) {
      pollingInterval = setInterval(updateResultsStatus, 300); // Check every 5 seconds
    }
    try {
      return () => {
        clearInterval(pollingInterval);
      } // Clear polling on unmount or when parsing stops
    } catch (e) {
      // do nowt
    }
  }, [isRunning]); //

  const updateResultsStatus = () => {
    const timeDiff = (Date.now() - startTimeRef.current) / 1000;
    setResultsStatus(timeDiff)

  }
    */
  function clearResults() {
    setP1Results("");
    setP2Results("");
    setP3Results("");
    setValidatorResults("");
  }


  /*
  async function loadDomLookup() {
    console.log(docRef.current.itemId);
    indexRef.current = 0;
    setProcessingState({ ...processingState, currentIndex: indexRef.current });
    startTimeRef.current = Date.now();
    setIsRunning(true);

    const body = { pk: "LOOKUP", sk: "DOMN", mode: "get" };
    const result = await getResults(body);
    const ptype = project.type;
    let domLookup = [];
    console.log(result);
  
    if (result.status && result.data) {
      domLookup = result.data.content.rows.map(row =>
        Object.fromEntries(result.data.content.columns.map((h, i) => [h.trim(), row[i].trim()]))
      );
    }
    console.log(ptype);
    console.log(domLookup);
    const ptypeDomLookup = domLookup.filter(obj =>
      obj.domain_code.includes(`DOMN-${ptype}`)
    );
    console.log(ptypeDomLookup);


    setDomLookup(ptypeDomLookup);

    setIsRunning(false);
  }

    const loadNTABArtefacts = async () => {
      console.log(docRef.current.itemId);
      indexRef.current = 0;
      setProcessingState({ ...processingState, currentIndex: indexRef.current });
      startTimeRef.current = Date.now();
      setIsRunning(true);
      const arts = await getArtefacts();
      const ntabArts = arts.data.filter(item => item.content.related_ntabs !== "");
      console.log(ntabArts);
      setNtabArtefacts(ntabArts);
      setIsRunning(false);
    }
  
    function getArtefacts() {
      return API.get("findigai", "/artefacts/" + docRef.current.itemId);
    }
  */
 /*
  function getOpenAI(body) {
    return API.post("findigai", "/openai", {
      body: body
    });
  }
    */
  /*
  function getNTABResults(body) {
    return API.post("findigai", "/results", {
      body: body
    });
  }*/
  function getResults(body) {
    return API.post("findigai", "/results/mode", {
      body: body
    });
  }
/*
  function validate(body) {
    return API.post("findigai", "/validation", {
      body: body
    });
  }
*/
  function handleTabChange(event, value) {
    event.preventDefault();
    console.log(value);
    setTabProcess(value);
    setTabStep(value);
  };





  const loadConfig = () => {
    console.log(config);
    console.log(config.dom);
    console.log(config.dom.options);
    const cf = config.dom.options;
    setPromptUserP1(cf?.promptUserP1 || "");
    setPromptSysP1(cf?.promptSysP1 || "");
    setPromptUserP2(cf?.promptUserP2 || "");
    setPromptSysP2(cf?.promptSysP2 || "");
    setPromptUserP3(cf?.promptUserP3 || "");
    setPromptSysP3(cf?.promptSysP3 || "");
    //setSdoList(cf?.sdos || "");
    //setValidatorOptions(cf?.validator || "");
    setTemperature(cf?.temperature || 0.0);
    setTopP(cf?.topP || 1.0);
    setPresencePenalty(cf?.presencePenalty || 0.0);
    setFrequencyPenalty(cf?.frequencyPenalty || 0.0);
    setSelectedModel(cf?.model || "");
  }



/*
  const handleProcessDomainsClick = (event) => {
    startTimeRef.current = Date.now();
    setIsRunning(true);
    clearResults();
    //updateSteps(2, true);
    deleteAllExisting();
    initiatePipeLineForNextQuery(0);
  }
    */
    const handleProcessDomainsClick = async (event) => {
    event.preventDefault();
    clearResults();
    startPipeline("DOM", completePipeline, { config: getConfigObj() });
  }

  const handleRestartDomsClick = async (event) => {
    event.preventDefault();
    clearResults();
    startPipeline("DOM", completePipeline, { restart: true, config: getConfigObj() });
  }
  /*
  const handleProcessNTABArtefactsClick = (event) => {
    startTimeRef.current = Date.now();
    setIsRunning(true);
    clearResults();
    deleteAllExisting();
    initiatePipeLineForNextArtefact(0);
  }
    

  async function deleteAllExisting() {
    await getResults({ pk: docRef.current.itemId, sk: `GOL|`, mode: "delete-all" });
    await getResults({ pk: docRef.current.itemId, sk: `DOM|`, mode: "delete-all" });
  }

  const initiatePipeLineForNextQuery = async (index) => {
    if (index >= domLookup.length) {
      updateSteps(3, true);
      downloadResults("P1", false);
      downloadResults("P2", false);
      downloadResults("P3", false);
      //downloadResults("VAL", false);
      
      setIsRunning(false);
      //alert("Domain processing succeded");
    } else {
      setProcessingState({ ...processingState, currentIndex: index });
      setProcessText("P1 querying");
      //console.log(ntabArtefacts[processingState.currentIndex].content.related_ntabs);
      await runPxQuery("P1", index);
    }
  }
*/
  /*
  function setValidationResults(rawResult) {
    console.log(rawResult);
    let errorHtml = "<b>unable to retrieve errors</b>";
    if (rawResult) {
      const errors = rawResult;//.data.content;
      errorHtml = "<b>no errors</b>";
      if (errors.length > 0) {
        let currentNtab = "";
        errors.forEach((error, index) => {
          if (currentNtab == "") {
            errorHtml = "<h6><b>" + error.ntabId + "</b></h6>";
            currentNtab = error.ntabId;
          } else if (currentNtab != error.ntabId) {
            errorHtml += "<br/><br/><h6><b>" + error.ntabId + "</b></h6>";
            currentNtab = error.ntabId;
          }
          errorHtml += "&nbsp;&nbsp;&nbsp;<b>" + error.type + "</b><br/>";
          Object.entries(error.details).forEach(([key, detail]) => {
            if (key == "fixes") {
              errorHtml += "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;fixes:<br/>";
              Object.entries(detail).forEach(([key2, detail2]) => {
                errorHtml += "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" + key2 + ": " + detail2 + "<br/>";
              });
            } else {
              errorHtml += "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" + key + ": " + detail + "<br/>";
            }
          });
        });
      }
    }
    return errorHtml;
  }
      */


/*
  async function runPxQuery(params = {}) {
    console.log(type, index);
    const newUserKey = processingState.userKey === 2 ? 1 : 2;
    setProcessingState({ ...processingState, userKey: newUserKey });
    let resultsStr = "";
    try {
      const body = { ...params, type: "DOM", prjid: project.itemId, docid: docRef.current.itemId, projectType: project.type, config: getConfigObj() };
      //const body = { type: "DOM", subtype: type, prjid: project.itemId, docid: docRef.current.itemId, domid: domainCode(), dom: domLookup[indexRef.current], projectType: project.type, keyid: newUserKey, isLastItem: index == domLookup.length-1, config: getConfigObj() };
      const result = await getOpenAI(body);
      console.log(result);
      resultsStr = result.body;
      setPromptId(type);
      return { status: true, result: resultsStr };
    } catch (err) {
      console.log("OpenAI Error:", err?.response?.data || err.message || err);
      resultsStr = "OpenAI Error: " + err?.response?.data || err.message || err;
      return { status: true, result: resultsStr };
    }
  }
    */
/*
    async function runPxQuery(params = {}) {
    startTimeRef.current = Date.now();
    setIsRunning(true);
    clearResults();
    try {
      const body = { ...params, type: "DOM", prjid: project.itemId, docid: docRef.current.itemId, projectType: project.type, fullPipeline: completePipeline, config: getConfigObj() };
      const result = await getOpenAI(body);
      setIsProcessing(true);
      console.log(result);
    } catch (err) {
      console.log("OpenAI Error:", err?.response?.data || err.message || err);
    }
  }
    */
/*
    useEffect(() => {
      let pollingInterval;
      if (isRunning && isProcessing) {
        pollingInterval = setInterval(pollDomStatus, 5000); // Check every 5 seconds
      }
      try {
        return () => clearInterval(pollingInterval); // Clear polling on unmount or when parsing stops
      } catch (e) {
        // do nowt
      }
  
    }, [isRunning, isProcessing]);
  
    const pollDomStatus = async () => {
      const result = await getResults({ pk: project.itemId, sk: `PRJ|DOC|${docRef.current.itemId}`, mode: "get" });
      const doc = result.data;
  
      onDocUpdated(doc);
  
      if (doc.pipeline.state === "complete") {
        setIsRunning(false);
        downloadResults("P1", false);
        downloadResults("P2", false);
        downloadResults("P3", false);
        setIsProcessing(false);
      } else {
        console.log(doc.pipeline.subType, doc.pipeline.state);
        if (doc.pipeline.subType === "PY") {
          console.log("........................................................................................");
          for (let i = 0; i < doc.pipeline.domains.doms.length; i++) {
            console.log(i, doc.pipeline.domains.doms[i].state);
            console.log("........................................................................................");
          }
        }
      }
    }
      */
/*
  const domainCode = () => {
    const code = domLookup[indexRef.current].domain_code.replace("DOMN-", "");
    return code;
  }

  const pollStatus = async () => {
    //const ntabType = promptId.startsWith("ntab") ? ntabId.slice(4) : "";
    const body = { pk: docRef.current.itemId, sk: `DOM|${promptId}|${domainCode()}`, mode: "get" };
    const result = await getResults(body);

    console.log(body);
    console.log(result);
    if (result.status && result.data && result.data.itemStatus > 0) {
      const currentId = promptId;
      setPromptId(null);
      if (currentId == "P1") {
        console.log("P2 querying");
        setProcessText("P2 querying");
        runPxQuery("P2", indexRef.current);
      } else if (currentId == "P2") {
        console.log("P3 querying");
        setProcessText("P3 querying");

        runPxQuery("P3", indexRef.current);
      } else if (currentId == "P3") {
        console.log("Validating");
        setProcessText("Validating");

        //const valResult = await validate({ type: "MAIN-NTAB", docid: docRef.current.itemId, artid: ntabArtefacts[indexRef.current].itemId });
        //console.log(valResult);
        indexRef.current++;
        initiatePipeLineForNextQuery(indexRef.current);
      }
    } else if (result.error && result.findigCode && result.findigCode == 3) {
      // Do nowt ie record not yet created
    } else {
      setIsRunning(false);
      alert("Domain Processing Failed - see logs");
    }
  }
*/

  const saveConfig = async () => {
    startTimeRef.current = Date.now();
    setIsRunning(true);
    const body = getConfigObj();
    await updateConfig(body);
    setIsRunning(false);
    // resetResults();
  }



  function getConfigObj() {
    return { type: "dom", values: { options: { promptSysP1: promptSysP1, promptUserP1: promptUserP1, promptSysP2: promptSysP2, promptUserP2: promptUserP2, promptSysP3: promptSysP3, promptUserP3: promptUserP3, model: selectedModel, temperature: temperature, topP: topP, presencePenalty: presencePenalty, frequencyPenalty: frequencyPenalty } } };
  }


  const handleTopPChange = async (e) => {
    e.preventDefault();
    let newValue = Number(e.target.value);
    if (newValue >= 1) newValue = 1.0;
    if (newValue < 1) newValue = 0.0;
    setTopP(newValue);
  }
  const handleTemperatureChange = async (e) => {
    e.preventDefault();
    let newValue = Number(e.target.value);
    if (newValue >= 1) newValue = 1.0;
    if (newValue < 1) newValue = 0.0;
    setTemperature(newValue);
  }
  const handlePresencePenaltyChange = async (e) => {
    e.preventDefault();
    let newValue = Number(e.target.value);
    if (newValue >= 1) newValue = 1.0;
    if (newValue < 1) newValue = 0.0;
    setPresencePenalty(newValue);
  }
  const handleFrequencyPenaltyChange = async (e) => {
    e.preventDefault();
    let newValue = Number(e.target.value);
    if (newValue >= 1) newValue = 1.0;
    if (newValue < 1) newValue = 0.0;
    setFrequencyPenalty(newValue);
  }

  const handleValidatorOnlyClick = async (event) => {
    //validateNTAB(enrichedNtab);

  }

  const copyToClipboard = (e, stage) => {
    e.preventDefault();
    let text = "";
    switch (stage) {
      case "P1":
        text = p1Results;
        break;
      case "P2":
        text = p2Results;
        break;
      case "P3":
        text = p3Results;
        break;
    }
    navigator.clipboard.writeText(text)
      .then(() => {
        console.log("Text copied to clipboard!");
        setCopied(true);
        setTimeout(() => setCopied(false), 1500); // hide after 2 sec
      })
      .catch(err => {
        console.error("Failed to copy: ", err);
      });
  }


const downloadResults = async (stage, timer = false) => {
    if (timer) {
      startTimeRef.current = Date.now();
      setIsRunning(true);
    }
    let body = { pk: docid, sk: `DOM|${stage}|`, mode: "query" };
    const results = await getResults(body);
    let text = "";
    for (const tab of results.data) {

        text += `${tab.sk} ----------------------------------------------------------------------------------------------------------------------------\n`;
        text += `PROMPT >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>\n`;
        text += `${tab.prompt}\n`;
        text += `\n<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<\n`;
        text += `\nOUTPUT:\n`;
        text += JSON.stringify(tab.content, null, 2);
        text += `\n-------------------------------------------------------------------------------------------------------------------------------------\n\n`;


    }
    //console.log(text);
    switch (stage) {
      case "P1":
        setP1Results(text);
        break;
      case "P2":
        setP2Results(text);
        break;
      case "P3":
        setP3Results(text);
        break;
      case "VAL":
        //setValidatorResults(text);
        break;
    }
    if (timer) {
      setIsRunning(false);
    }
  }
/*
  const downloadResults = async (stage, timer = false) => {
    if (timer) {
      startTimeRef.current = Date.now();
      setIsRunning(true);
    }
    let body = { pk: docRef.current.itemId, sk: `DOM|${stage}|`, mode: "query" };
    const results = await getResults(body);
    let text = "";
    for (const tab of results.data) {
      if (stage === "VAL") {
        //text += `<b>${tab.sk}</b> ----------------------------------------------------------------------------------------------------------------------------<br/><br/>`;
        //text += setValidationResults(tab.content);
        //text += `<br/>-------------------------------------------------------------------------------------------------------------------------------------<br/><br/>`;

      } else {
        text += `${tab.sk}\n`;
        text += JSON.stringify(tab.content, null, 2);
        text += `\n-------------------------------------------------------------------------------------------------------------------------------------\n\n`;

      }
    }
    //console.log(text);
    switch (stage) {
      case "P1":
        setP1Results(text);
        break;
      case "P2":
        setP2Results(text);
        break;
      case "P3":
        setP3Results(text);
        break;
      case "VAL":
        //setValidatorResults(text);
        break;
    }
    if (timer) {
      setIsRunning(false);
    }
  }
*/



  const loadResults = async (e, stage) => {
    e.preventDefault();
    downloadResults(stage, true);
  }

  function renderLander() {
    return (



      <Box p={0} sx={{ backgroundColor: "#fff" }}>
        <Box px={2} >
          <h6> {Number(resultsStatus) > 0 ? String(Number(resultsStatus).toFixed(1)) + " seconds." : ""}</h6>
        </Box>

                <Box px={2} my={2} display="flex" alignItems='center' flexDirection="row" >
                  <Button disabled={disabled || docItemStatus < 3 || docPhase === "DOM"} onClick={handleProcessDomainsClick} color="primary" variant="contained" component="span" startIcon={<PlayArrowIcon />}>Run DOMAINs pipeline</Button>
                  <Box pl={2}><Button disabled={disabled || docItemStatus < 3} onClick={handleRestartDomsClick} color="primary" variant="contained" component="span" startIcon={<PlayArrowIcon />}>Restart</Button></Box>






                  <Box mx={1} display="flex" alignItems="center">
                    <FormControlLabel
                      style={{ margin: 0, display: "flex", alignItems: "center" }}
                      control={
                        <Checkbox
                          checked={completePipeline}
                          onChange={(e) => setCompletePipeline(e.target.checked)}
                          color="primary"
                          size="small"
                        />
                      }
                      label="Complete full pipeline from here"
                    />
                  </Box>
                </Box>
        

        <CustomStepper steps={steps} activeStep={activeStep} />
        <Box px={1} sx={{
          width: '100%',
          bgcolor: 'white',
          color: 'white',
        }}>
          <CustomTabs
            tabs={steps}
            value={tabStep}
            onChange={handleTabChange}
          />
          <Box p={2} sx={{
            width: '100%',
            bgcolor: '#33337733',
            color: '#330',
          }}>






            <>



              <Box mt={1} sx={{ width: "100%" }}>
                <Paper style={{ backgroundColor: "#f2f2ff" }}>

                  <Box p={2}>



                    <Paper style={{ backgroundColor: "#efe" }}>
                      <Box p={1}>



                        {tabProcess == 0 ?
                          <>

                            <Paper style={{ backgroundColor: "#ffe" }}>
                              <Box p={1} mb={4}>

                                <Box display="flex" alignItems='center' flexDirection="row" >
                                  <Box pv={2} pl={0.5}>
                                    <h6>P1 results</h6>
                                  </Box>
                                  <Box sx={{ flexGrow: 1 }} ></Box>
                                  <Box mx={1} pb={1}>
                                    <Tooltip title="download existing results">
                                      <IconButton
                                        onClick={(e) => { loadResults(e, "P1") }}
                                        disabled={isRunning}
                                        size="small"
                                      >
                                        <DownloadIcon />
                                      </IconButton>
                                    </Tooltip>
                                  </Box>
                                  <Box mx={1} pb={1}>
                                    <Tooltip title="Copy results to clipboard">
                                      <IconButton
                                        onClick={(e) => { copyToClipboard(e, "P1") }}
                                        disabled={isRunning}
                                        size="small"
                                      >
                                        <FileCopyIcon />
                                      </IconButton>
                                    </Tooltip>
                                    {copied && <span style={{ marginLeft: 10, color: 'green' }}>Copied!</span>}
                                  </Box>
                                </Box>

                                <TextareaAutosize
                                  disabled={isRunning}
                                  minRows={1}
                                  placeholder="<empty>"
                                  value={p1Results}
                                  onChange={(e) => setP1Results(e.target.value)}
                                  style={{
                                    width: '100%',
                                    padding: '12px',
                                    fontSize: '16px',
                                    borderRadius: '8px',
                                    border: '1px solid #ccc',
                                    resize: 'vertical',
                                  }}
                                />
                              </Box>
                            </Paper>







                            <Box pv={2} pl={0.5}>
                              <h6>System prompt (P1)</h6>
                            </Box>
                            <Paper style={{ backgroundColor: "#fff" }}>
                              <Box p={1}>
                                <HighlightWithinTextarea
                                  disabled={isRunning}
                                  placeholder="<empty>"
                                  value={promptSysP1 ?? ""}
                                  highlight={[
                                    { highlight: [/<<<[\s\S]*?>>>/g], className: 'blue' },
                                    { highlight: [/(?<=<<\[)[\s\S]*?(?=\]>>)/g], className: 'green' },
                                    { highlight: [/{{{[\s\S]*?}}}/g], className: 'red' }
                                  ]}
                                  onChange={(text) => setPromptSysP1(text)}
                                />
                              </Box>
                            </Paper>


                            <Box pt={3} pb={0} pl={0.5} >
                              <h6>User prompt (P1)</h6>
                            </Box>
                            <Box py={1}>
                              <InsertsChecklist inserts={["{{{objectives-guidance}}}", "{{{information-needs}}}", "{{artefacts}}}", "{{{relevant-ntabs}}}"]} text={promptUserP1} />
                            </Box>
                            <Paper style={{ backgroundColor: "#fff" }}>
                              <Box p={1}>
                                <HighlightWithinTextarea
                                  disabled={isRunning}
                                  placeholder="<empty>"
                                  value={promptUserP1 ?? ""}
                                  highlight={[
                                    { highlight: [/<<<[\s\S]*?>>>/g], className: 'blue' },
                                    { highlight: [/(?<=<<\[)[\s\S]*?(?=\]>>)/g], className: 'green' },
                                    { highlight: [/{{{[\s\S]*?}}}/g], className: 'red' }
                                  ]}
                                  onChange={(text) => setPromptUserP1(text)}
                                />
                              </Box>
                            </Paper>

                          </>
                          : tabProcess == 1 ?
                            <>


                              <Paper style={{ backgroundColor: "#ffe" }}>
                                <Box p={1} mb={4}>



                                  <Box display="flex" alignItems='center' flexDirection="row" >
                                    <Box pv={2} pl={0.5}>
                                      <h6>P2 results</h6>
                                    </Box>
                                    <Box sx={{ flexGrow: 1 }} ></Box>
                                    <Box mx={1} pb={1}>
                                      <Tooltip title="download existing results">
                                        <IconButton
                                          onClick={(e) => { loadResults(e, "P2") }}
                                          disabled={isRunning}
                                          size="small"
                                        >
                                          <DownloadIcon />
                                        </IconButton>
                                      </Tooltip>
                                    </Box>
                                    <Box mx={1} pb={1}>
                                      <Tooltip title="Copy results to clipboard">
                                        <IconButton
                                          onClick={(e) => { copyToClipboard(e, "P2") }}
                                          disabled={isRunning}
                                          size="small"
                                        >
                                          <FileCopyIcon />
                                        </IconButton>
                                      </Tooltip>
                                      {copied && <span style={{ marginLeft: 10, color: 'green' }}>Copied!</span>}
                                    </Box>
                                  </Box>




                                  <TextareaAutosize
                                    disabled={true}
                                    placeholder="<empty>"
                                    minRows={1}
                                    value={p2Results}
                                    onChange={(e) => setP2Results(e.target.value)}
                                    style={{
                                      width: '100%',
                                      padding: '12px',
                                      fontSize: '16px',
                                      borderRadius: '8px',
                                      border: '1px solid #ccc',
                                      resize: 'vertical',
                                    }}

                                  />

                                </Box>
                              </Paper>

                              <Box pv={2} pl={0.5}>
                                <h6>System prompt (P2)</h6>
                              </Box>
                              <Paper style={{ backgroundColor: "#fff" }}>
                                <Box p={1}>
                                  <HighlightWithinTextarea
                                    disabled={isRunning}
                                    placeholder="<empty>"
                                    value={promptSysP2 ?? ""}
                                    highlight={[
                                      { highlight: [/<<<[\s\S]*?>>>/g], className: 'blue' },
                                      { highlight: [/(?<=<<\[)[\s\S]*?(?=\]>>)/g], className: 'green' },
                                      { highlight: [/{{{[\s\S]*?}}}/g], className: 'red' }
                                    ]}
                                    onChange={(text) => setPromptSysP2(text)}
                                  />
                                </Box>
                              </Paper>

                              <Box pt={3} pb={0} pl={0.5} >
                                <h6>User prompt (P2)</h6>
                              </Box>
                              <Box py={1}>
                                <InsertsChecklist inserts={["{{{objectives-guidance}}}", "{{artefacts}}}", "{{{associated-signal-codes}}}", "{{{p1-output}}}", "{{{subprompt_p2_01}}}", "{{{subprompt_p2_02}}}"]} text={promptUserP2} />
                              </Box>

                              <Paper style={{ backgroundColor: "#fff" }}>
                                <Box p={1}>
                                  <HighlightWithinTextarea
                                    disabled={isRunning}
                                    placeholder="<empty>"
                                    value={promptUserP2 ?? ""}
                                    highlight={[
                                      { highlight: [/<<<[\s\S]*?>>>/g], className: 'blue' },
                                      { highlight: [/(?<=<<\[)[\s\S]*?(?=\]>>)/g], className: 'green' },
                                      { highlight: [/{{{[\s\S]*?}}}/g], className: 'red' }
                                    ]}
                                    onChange={(text) => setPromptUserP2(text)}
                                  />
                                </Box>
                              </Paper>
                              {/*}
                              <Box pv={2} pl={0.5}>
                                <h6>SDOs (in CSV table format)</h6>
                              </Box>



                              <TextareaAutosize
                                disabled={isRunning}
                                minRows={1}
                                placeholder="<empty>"
                                value={sdoList}
                                onChange={(e) => setSdoList(e.target.value)}
                                style={{
                                  width: '100%',
                                  padding: '12px',
                                  fontSize: '16px',
                                  borderRadius: '8px',
                                  border: '1px solid #ccc',
                                  resize: 'vertical',
                                }}
                              />
                              */}

                            </>
                            : tabProcess == 2 ?
                              <>


                                <Paper style={{ backgroundColor: "#ffe" }}>
                                  <Box p={1} mb={4}>



                                    <Box display="flex" alignItems='center' flexDirection="row" >
                                      <Box pv={2} pl={0.5}>
                                        <h6>P3 results </h6>
                                      </Box>
                                      <Box sx={{ flexGrow: 1 }} ></Box>
                                      <Box mx={1} pb={1}>
                                        <Tooltip title="download existing results">
                                          <IconButton
                                            onClick={(e) => { loadResults(e, "P3") }}
                                            disabled={isRunning}
                                            size="small"
                                          >
                                            <DownloadIcon />
                                          </IconButton>
                                        </Tooltip>
                                      </Box>
                                      <Box mx={1} pb={1}>
                                        <Tooltip title="Copy results to clipboard">
                                          <IconButton
                                            onClick={(e) => { copyToClipboard(e, "P3") }}
                                            disabled={isRunning}
                                            size="small"
                                          >
                                            <FileCopyIcon />
                                          </IconButton>
                                        </Tooltip>
                                        {copied && <span style={{ marginLeft: 10, color: 'green' }}>Copied!</span>}
                                      </Box>
                                    </Box>


                                    <TextareaAutosize
                                      disabled={isRunning}
                                      minRows={1}
                                      placeholder="<empty>"
                                      value={p3Results}
                                      onChange={(e) => setP3Results(e.target.value)}
                                      style={{
                                        width: '100%',
                                        padding: '12px',
                                        fontSize: '16px',
                                        borderRadius: '8px',
                                        border: '1px solid #ccc',
                                        resize: 'vertical',
                                      }}
                                    />
                                  </Box>
                                </Paper>

                                <Box pv={2} pl={0.5}>
                                  <h6>System prompt (P3)</h6>
                                </Box>

                                <Paper style={{ backgroundColor: "#fff" }}>
                                  <Box p={1}>
                                    <HighlightWithinTextarea
                                      disabled={isRunning}
                                      placeholder="<empty>"
                                      value={promptSysP3 ?? ""}
                                      highlight={[
                                        { highlight: [/<<<[\s\S]*?>>>/g], className: 'blue' },
                                        { highlight: [/(?<=<<\[)[\s\S]*?(?=\]>>)/g], className: 'green' },
                                        { highlight: [/{{{[\s\S]*?}}}/g], className: 'red' }
                                      ]}
                                      onChange={(text) => setPromptSysP3(text)}
                                    />
                                  </Box>
                                </Paper>

                                <Box pt={3} pb={0} pl={0.5} >
                                  <h6>User prompt (P3)</h6>
                                </Box>
                                <Box py={1}>
                                  <InsertsChecklist inserts={["{{{p2-output}}}", "{{{subprompt_p3_01}}}", "{{{subprompt_p3_02}}}"]} text={promptUserP3} />
                                </Box>
                                <Paper style={{ backgroundColor: "#fff" }}>
                                  <Box p={1}>
                                    <HighlightWithinTextarea
                                      disabled={isRunning}
                                      placeholder="<empty>"
                                      value={promptUserP3 ?? ""}
                                      highlight={[
                                        { highlight: [/<<<[\s\S]*?>>>/g], className: 'blue' },
                                        { highlight: [/(?<=<<\[)[\s\S]*?(?=\]>>)/g], className: 'green' },
                                        { highlight: [/{{{[\s\S]*?}}}/g], className: 'red' }
                                      ]}
                                      onChange={(text) => setPromptUserP3(text)}
                                    />
                                  </Box>
                                </Paper>

                              </>
                              :
                              <>
                                {/*}
                                <Box p={2} mb={1}>
                                  <Button disabled={enrichedNtab == "" || isRunning} onClick={handleValidatorOnlyClick} color="primary" variant="contained" component="span" startIcon={<PlayArrowIcon />}>Run Validator ONLY</Button>
                                </Box>

                                <Box pv={2} pl={0.5}>
                                  <h6>Enriched NTAB (as CSV)</h6>
                                </Box>


                                <TextareaAutosize
                                  disabled={isRunning}
                                  minRows={1}
                                  placeholder="<empty>"
                                  value={enrichedNtab}
                                  onChange={(e) => setEnrichedNtab(e.target.value)}
                                  style={{
                                    width: '100%',
                                    padding: '12px',
                                    fontSize: '16px',
                                    borderRadius: '8px',
                                    border: '1px solid #ccc',
                                    resize: 'vertical',
                                  }}
                                />
                                */}




                                <Box display="flex" alignItems='center' flexDirection="row" >
                                  <Box pv={2} pl={0.5}>
                                    <h6>Validation Results</h6>
                                  </Box>
                                  <Box sx={{ flexGrow: 1 }} ></Box>
                                  <Box mx={1} pb={1}>
                                    <Tooltip title="download existing results">
                                      <IconButton
                                        onClick={(e) => { loadResults(e, "VAL") }}
                                        disabled={isRunning}
                                        size="small"
                                      >
                                        <DownloadIcon />
                                      </IconButton>
                                    </Tooltip>
                                  </Box>
                                  <Box mx={1} pb={1}>
                                    <Tooltip title="Copy results to clipboard">
                                      <IconButton
                                        onClick={(e) => { copyToClipboard(e, "VAL") }}
                                        disabled={isRunning}
                                        size="small"
                                      >
                                        <FileCopyIcon />
                                      </IconButton>
                                    </Tooltip>
                                    {copied && <span style={{ marginLeft: 10, color: 'green' }}>Copied!</span>}
                                  </Box>
                                </Box>

                                <Box sx={{ p: 2, border: "1px solid #ccc" }}
                                  dangerouslySetInnerHTML={{ __html: validatorResults }}>
                                </Box>

                              </>
                        }



                      </Box>
                    </Paper>


                    {tabProcess < 3 &&
                      <>
                        <Box display="flex" alignItems='center' flexDirection="row" flexWrap='nowrap' overflowWrap='break-all'>

                          <Box width={26} pt={3} pb={0} pl={0.5} >
                            <Paper>
                              <TextField
                                type="number"
                                disabled={isRunning}
                                value={temperature}
                                onChange={handleTemperatureChange}
                                disableUnderline
                                inputProps={{
                                  disableUnderline: true,
                                  min: 0,
                                  max: 1,
                                }}
                              />
                            </Paper>
                          </Box>
                          <Box pt={3} pb={0} pl={0.5} >
                            <h6> Temperature</h6>
                          </Box>
                        </Box>

                        <Box display="flex" alignItems='center' flexDirection="row" flexWrap='nowrap' overflowWrap='break-all'>

                          <Box width={26} pt={3} pb={0} pl={0.5} >
                            <Paper>
                              <TextField
                                type="number"
                                disabled={isRunning}
                                value={topP}
                                onChange={handleTopPChange}
                                disableUnderline
                                inputProps={{
                                  disableUnderline: true,
                                  min: 0,
                                  max: 1,
                                }}
                              />
                            </Paper>
                          </Box>
                          <Box pt={3} pb={0} pl={0.5} >
                            <h6> Top P</h6>
                          </Box>
                        </Box>

                        <Box display="flex" alignItems='center' flexDirection="row" flexWrap='nowrap' overflowWrap='break-all'>

                          <Box width={26} pt={3} pb={0} pl={0.5} >
                            <Paper>
                              <TextField
                                type="number"
                                disabled={isRunning}
                                value={presencePenalty}
                                onChange={handlePresencePenaltyChange}
                                disableUnderline
                                inputProps={{
                                  disableUnderline: true,
                                  min: 0,
                                  max: 1,
                                }}
                              />
                            </Paper>
                          </Box>
                          <Box pt={3} pb={0} pl={0.5} >
                            <h6> Presence penalty</h6>
                          </Box>
                        </Box>
                        <Box display="flex" alignItems='center' flexDirection="row" flexWrap='nowrap' overflowWrap='break-all'>

                          <Box width={26} pt={3} pb={0} pl={0.5} >
                            <Paper>
                              <TextField
                                type="number"
                                disabled={isRunning}
                                value={frequencyPenalty}
                                onChange={handleFrequencyPenaltyChange}
                                disableUnderline
                                inputProps={{
                                  disableUnderline: true,
                                  min: 0,
                                  max: 1,
                                }}
                              />
                            </Paper>
                          </Box>
                          <Box pt={3} pb={0} pl={0.5} >
                            <h6> Frequency penalty</h6>
                          </Box>
                        </Box>

                        <Box my={2} ml={0.5}>
                          <select
                            id="model"
                            disabled={isRunning}
                            value={selectedModel}
                            onChange={(e) => setSelectedModel(e.target.value)}
                          >
                            {models.map((model) => (
                              <option key={model.value} value={model.value}>
                                {model.label}
                              </option>
                            ))}
                          </select>

                        </Box>


                        <Box pt={3} pb={0} pl={0.5} >
                          <p style={{ fontSize: "0.75rem" }}><i>Note: To save the prompts and params without running the query use the SAVE button. The prompts and params will be automatically saved if you run the query.</i></p>
                        </Box>
                        <Box display="flex" alignItems='center' flexDirection="row" flexWrap='nowrap' overflowWrap='break-all'>
                          <Box sx={{ flexGrow: 1 }} ></Box>
                          <Box my={2} mr={3}>
                            <Button
                              variant="contained" component="span"
                              disabled={isRunning}
                              onClick={(e) => {
                                e.preventDefault();
                                saveConfig();
                              }} color="primary">
                              Save
                            </Button>
                          </Box>
                        </Box>




                      </>
                    }


                  </Box>
                </Paper>
              </Box>



            </>






          </Box>
          <Box p={2} sx={{
            width: '100%',
            bgcolor: 'white',
            color: 'white',
          }}>
          </Box>
        </Box>

      </Box>

    )
  }
  return (
    <>
      {renderLander()}
      {/*domLookup && domLookup.length > 0 && domLookup[indexRef.current] && //domLookup[indexRef.current].content && domLookup[indexRef.current].content.related_ntabs &&
        <LoadingModal open={isRunning} message={indexRef.current > -1 ? `Domain: ${indexRef.current + 1}/${domLookup.length} (${domLookup[indexRef.current].domain_code})` : "Processing..."} message2={processText + "..."} message3={Number(resultsStatus).toFixed(1) + " seconds"} />
      */}
        <LoadingModal open={isRunning} message={ "Processing..."} message2={processText + "..."} message3={Number(resultsStatus).toFixed(1) + " seconds"} />
    </>
  )
}